import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as Action_App from '../../../actions/app'
import * as Action_User from '../../../actions/user'
import * as Action_Util from '../../../actions/util'

import {InputItem, Popup, Table, Icon, SearchBar,Modal,Button,List,Radio,NavBar} from 'antd-mobile'

const objectAssign = require('object-assign');

class Customer extends React.Component {
	constructor(props) {
		super(props);
		const {actions,appStates,customerParams,customerList} = props;
		actions.setScrollHeight(1.8);
		if(!customerList || customerList.length == 0){
	    	actions.resetCustomerParams();
			actions.getCustomerlist(customerParams);
		}
    }
	render(){
		const {params,loading,orderFields,scrollHeight,customerList,customerParams,customerCount,actions} = this.props;
		const value = !!orderFields.c_id ? orderFields.c_id.value : null;
		return (
			<div className='csm-body-wapper'>
				<NavBar onLeftClick={this.goBack.bind(this)}
				rightContent={<span className="csm-navbar-right-icon" onClick={this.doSub.bind(this)}>确定</span>}>
                   	选择客户
                </NavBar>
				<SearchBar ref="SearchBar" className='csm-customer-search-bar' placeholder="搜索" onSubmit={value=>actions.goNextPage({search:value,current:1})} />
				<div
				onTouchEnd={()=>{
                    let parent = document.getElementsByClassName('am-list')[0];
                    let child = parent.getElementsByClassName('am-list-body')[0];
                    if(this.getLoadBool(parent,child) && customerParams.current < Math.ceil(customerCount/customerParams.pageSize)) {
                        actions.goNextPage({current:customerParams.current + 1});
                    }
                }}>
					<List className='csm-scroll-wapper' style={{height:scrollHeight}}>
		                {!loading && (!customerList || customerList.length == 0) ? <Button style={{border:0}}>没有数据</Button> : ""}
						{loading && <div style={{textAlign:"center",paddingBottom:"20px"}}>
			                <Button loading={true} style={{border:0}}>加载中</Button>
			            </div>}
	                	{!!customerList && customerList.length !== 0 ? customerList.map(r=>{
	                		return <Radio.RadioItem key={r.id} checked={r.id === value} onClick={this.chooseCustomer.bind(this,r)}>{r.name}<List.Item.Brief>{"客户经理：" + r.managername}</List.Item.Brief></Radio.RadioItem>
	                	}):""}
	                </List>
                </div>
			</div>
        )
	}
	goBack(){
		const {actions,router,params} = this.props;
		actions.chooseCustomer({id:'',name:''});
		router.push('/apply/' + params.id);
	}
	chooseCustomer(value){
		const {actions} = this.props;
		actions.chooseCustomer(value);
	}
	doSub(){
		const {actions,orderFields,router,params} = this.props;
		const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
		if(!!orderFields.c_id && !!orderFields.c_id.value){
			if(orderFields.c_name.value == 'E8TEST'){
				actions.setLicense(me.member.m_license)
			}else{
				const param = {
					ecname:orderFields.c_name.value,
					ecid:orderFields.c_id.value,
					access_token:me.token.access_token
				};
				actions.getLicense(param);
			}
			router.push('/apply/' + params.id)
		}else{
			Modal.alert('提示','您还没有选择客户，请选择后提交！',[{ text: 'ok', onPress: () => {}}]);
		}
	}
	getLoadBool(p,c){
		if(!p || !c) return false;
		let s = c.scrollHeight;
		let t = p.scrollTop;
		let h = p.offsetHeight;
		return s <= t + h + 10
	}
}

function mapStateToProps(state) {
    const {app,util,user} = state;
    return {
    	scrollHeight: util.scrollHeight,
        loading: util.loading,
        customerList: app.customerList,
        customerParams: app.customerParams,
        customerCount: app.customerCount,
        orderFields: app.orderFields,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(objectAssign({},Action_App,Action_User,Action_Util), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Customer);


// WEBPACK FOOTER //
// ./project/components/app/appApply/Customer.js